var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo:
            "Editar Configuración Base: " + _vm.certificadoSeleccionado.nombre,
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          entidad: "Configuración Base",
          nombreEntidad: _vm.certificadoSeleccionado
            ? _vm.certificadoSeleccionado.nombre
            : "",
          pasoActivoIndex: _vm.pasoActivoIndex
        },
        on: { cerrar: _vm.handleCerrar, guardar: _vm.handleGuardar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("ConfigurarCertificadoForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.configurarCertificado.step,
                expression:
                  "pasoActivoIndex === pasos.configurarCertificado.step"
              }
            ],
            attrs: {
              certificadoSeleccionado: _vm.certificadoSeleccionado,
              modoEditar: true
            },
            on: {
              change: _vm.handleFormChange,
              handleFormChange: _vm.handleFormChange,
              handleLogoTercero: _vm.handleLogoChange
            }
          }),
          _vm.pasoActivoIndex === _vm.pasos.editarTexto.step
            ? _c("ConfigurarCertificadoFormTexto", {
                attrs: {
                  certificadoSeleccionado: _vm.certificadoSeleccionado,
                  modoEditar: true
                },
                on: {
                  handleTexto: _vm.handleTextoChange,
                  handleFormTextoChange: _vm.handleFormTextoChange
                }
              })
            : _vm._e(),
          _vm.pasoActivoIndex === _vm.pasos.gpsVehiculo.step
            ? _c("ConfigurarCertificadoFormGps", {
                attrs: {
                  certificadoSeleccionado: _vm.certificadoSeleccionado,
                  modoEditar: true
                },
                on: { handleFormGps: _vm.handleFormGps }
              })
            : _vm._e()
        ],
        1
      ),
      _c("MensajeValidacion", {
        attrs: {
          showDialog: _vm.showValidacion,
          titulo: _vm.tituloValidacion,
          mensaje: _vm.mensajeValidacion,
          items: _vm.itemsNoValidos
        },
        on: {
          modalConfirmationEmit: function($event) {
            _vm.showValidacion = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }